import { render } from "./CertificatePage.vue?vue&type=template&id=1b6af368&scoped=true&ts=true"
import script from "./CertificatePage.vue?vue&type=script&lang=ts"
export * from "./CertificatePage.vue?vue&type=script&lang=ts"

import "./CertificatePage.vue?vue&type=style&index=0&id=1b6af368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6af368"]])

export default __exports__